import React, { useContext } from 'react'

import { NotesContext } from '../context'
import { CardHeading } from '../../../components/layout/Card'

export const Header = () => {
  const { state: { header, filter } } = useContext(NotesContext)
  return (
    <CardHeading>
      <h5>{header}</h5>
      {filter ? filter() : null}
    </CardHeading>
  )
}
